import { _Chart as LChart } from '../chart/StyledLineChart';
import { _Chart as DChart, customToNormalData } from '../chart/StyledDoughnutChart';
import { _Chart as BChart } from '../chart/StyledStackedBarChart';
import ChartOptions from "../chart/ChartOptions";
import AnalyticsTypes from "./AnalyticsTypes";
import GraphUtil from "./GraphUtil";
import AnalyticsEngine from "../data/AnalyticsEngine";
import moment from "moment";
import PapaParse from 'papaparse'
import {File} from "oca-lib-web";
import Constants from "./Constants";
import PrintManager from "./PrintManager";
import DashboardDateUtil from "./DashboardDateUtil";
import DatasetUtil from "./DatasetUtil";
import FarmCredit from "./FarmCredit";

export default class ExportUtil {

    private static printManager:PrintManager = new PrintManager();
    private static headerTop = 0;
    private static headerWidth = 0;
    private static headerHeight = 0;

    private static countersTop = 0;
    //private static countersWidth = 0;
    private static countersHeight = 0;

    private static linesTop = 0;
    private static linesWidth = 0;
    //private static linesHeight = 0;

    //doc.addFont("test/reference/unifont-13.0.06.ttf", "Unifont", "normal");
    //doc.setFont("Unifont"); // set font

    public static exportData(item:GraphSettings, timeInterval:TimeInterval) {
        let dataset = AnalyticsEngine.getDataset(item, timeInterval);

        var csv = PapaParse.unparse({
            fields: Object.keys(dataset[0]),
            data: dataset
        });

        let filename = item.dataSource + ".csv";
        File.download(csv, filename);
    }

    public static async downloadReport(analyticsSettings:ReportSettings, pageSettings:PageSettings, timeInterval:TimeInterval, project:ProjectModel) {
        console.log("downloadReport");

        // TODO: This should now be passed from the export dialog
        //let pageSettings = GraphUtil.getAnalyticsPage(CacheSettings.getCurrentPage(), project);
        //console.log(CacheSettings.getCurrentPage());
        //console.log(project);
        //console.log(pageSettings);

        let header = {
            header: {
                company: analyticsSettings.reportTitle || "",
                person: pageSettings.pageDescription || "",
                date: moment(timeInterval.start).format("MMMM DD, YYYY") + " - " + moment(timeInterval.end).subtract(1,'days').format("MMMM DD, YYYY"),
                device: project.projectName,
            }
        }

        let doc = await ExportUtil.generatePdf(analyticsSettings, pageSettings, timeInterval, project, header);
        //console.log("about to download");
        //console.log(doc);
        let pageDescription = pageSettings.pageDescription || project.projectName;
        let fileName = pageDescription + " " + moment(timeInterval.start).format("MMM YYYY") + ".pdf";
        doc.save(fileName);
    }

    private static async generatePdf(analyticsSettings:ReportSettings, pageSettings:PageSettings, timeInterval:TimeInterval, project:ProjectModel, data:any) {
        this.printManager.initDoc();

        //let doc = null;
        try {
            await this.renderReport(analyticsSettings, pageSettings, timeInterval, project, data);
            await this.renderReport(analyticsSettings, pageSettings, timeInterval, project, data);
        } catch (error) {
            console.error(error);
        }

        //console.log(this.printManager);
        return this.printManager.getDoc();
    }

    public static async renderReport(analyticsSettings:ReportSettings, pageSettings:PageSettings, timeInterval:TimeInterval, project:ProjectModel, data:any):Promise<any> {
        console.log("Starting report render");
        this.printManager.rect('back', 0, 0, 210, 297);

        if (FarmCredit.needsFarmCreditLogo(analyticsSettings)) {
            this.printManager.addImage(FarmCredit.cfcLogo, 150, 280, 50, 13);
        }

        /*
         * Render Header
         */
        //if (headerTop) {
            //headerHeight = 100;
            this.printManager.rect(analyticsSettings.primaryColor || 'headerGreen', 0, 0, 210, this.headerHeight);
            this.printManager.rect('white', PrintManager.pageLeft, this.headerTop, this.headerWidth, this.headerHeight);
        //}

        this.headerTop = PrintManager.pageTop;
        this.headerWidth = PrintManager.pageRight - PrintManager.pageLeft;

        this.printManager.y = this.printManager.startTop = this.headerTop + PrintManager.yPadding;
        this.printManager.x = this.printManager.startLeft = PrintManager.pageLeft + PrintManager.xPadding;

        this.printManager.addLineToDoc(data.header.company, {size: 'h1', color: 'black'});
        this.printManager.addLineToDoc(data.header.person, {size: 'h2', color: 'darkgrey'});

        if (this.headerHeight < this.printManager.y - this.printManager.getLineHeight() / 2 - this.headerTop + PrintManager.yPadding)
            this.headerHeight = this.printManager.y - this.printManager.getLineHeight() / 2 - this.headerTop + PrintManager.yPadding;

        this.printManager.y = this.printManager.startTop + 1;
        this.printManager.x = PrintManager.pageRight - PrintManager.xPadding;
        this.printManager.addLineToDoc(data.header.date, {size: 'h2', color: 'darkgrey', align: 'right'});
        this.printManager.x = PrintManager.pageRight - PrintManager.xPadding;
        this.printManager.addLineToDoc(data.header.device, {size: 'h2', color: 'blue', align: 'right'});

        if (this.headerHeight < this.printManager.y - this.printManager.getLineHeight() / 2 - this.headerTop + PrintManager.yPadding)
            this.headerHeight = this.printManager.y - this.printManager.getLineHeight() / 2 - this.headerTop + PrintManager.yPadding;

        /*
         * Render Textboxes
         */

        //let textGraphs:GraphSettings[] = GraphUtil.getTextGraphs(GraphUtil.getCurrentAnalyticsPage(project));
        let textGraphs:GraphSettings[] = GraphUtil.getTextGraphs(pageSettings);
        this.countersTop = this.printManager.y = this.headerTop + this.headerHeight + PrintManager.spacing;
        //this.countersWidth = (PrintManager.pageWidth - PrintManager.spacing);
        let textGraphHeight = 0;
        for (let textGraph of textGraphs) {
            var splitTitle = this.printManager.doc.splitTextToSize(textGraph.text.toString(), PrintManager.pageWidth);
            textGraphHeight = splitTitle.length * this.printManager.getLineHeight() + 5;
            this.printManager.rect('white', PrintManager.pageLeft, this.countersTop - 3, PrintManager.pageWidth, textGraphHeight - 2);
            this.printManager.addLineToDoc(textGraph.text, {size: 'h2', color: 'darkgrey', align: 'left'});
        }

        /*
         * Render Summary
         */
        //let allSummaryTypes:GraphSettings[] = GraphUtil.getSummaryGraphs(GraphUtil.getCurrentAnalyticsPage(project))
        let allSummaryTypes:GraphSettings[] = GraphUtil.getSummaryGraphs(pageSettings);
        let summaryTypes = [];
        for (let allSummaryType of allSummaryTypes) {
            if (!allSummaryType.hidden) {
                summaryTypes.push(allSummaryType);
            }
        }

        this.countersTop = this.printManager.y = this.headerTop + this.headerHeight + PrintManager.spacing + textGraphHeight;
        console.log(this.countersTop);

        // TODO: This is where we need to add a second line if possible
        let summaryTypesRow1:Array<GraphSettings> = summaryTypes.slice(0,3);
        let summaryTypesRow2:Array<GraphSettings> = summaryTypes.slice(3,6);
        let summaryTypeRows = [summaryTypesRow1, summaryTypesRow2];

        let summaryHeight = 18.0;
        if (this.countersHeight) {
            for (let i = 0; i < summaryTypeRows.length; i++) {
                let summaryWidth = (PrintManager.pageWidth - (summaryTypeRows[i].length - 1) * PrintManager.spacing) / summaryTypeRows[i].length;
                let yLocation = this.countersTop + (i == 1 ? summaryHeight + PrintManager.yPadding : 0);
                for (let j = 0; j < summaryTypeRows[i].length; j++) {
                    this.printManager.rect('white', PrintManager.pageLeft + j * (summaryWidth + PrintManager.spacing), yLocation, summaryWidth, summaryHeight);
                }
            }
        }

        for (let i = 0; i < summaryTypeRows.length; i++) {
            let summaryWidth = (PrintManager.pageWidth - (summaryTypeRows[i].length - 1) * PrintManager.spacing) / summaryTypeRows[i].length;
            if (i == 1 && summaryTypeRows[i].length > 0) {
                this.printManager.y += summaryHeight + PrintManager.yPadding;
                this.countersTop += summaryHeight + PrintManager.yPadding;
            }
            for (let j = 0; j < summaryTypeRows[i].length; j++) {
                let color = summaryTypeRows[i][j].graphColor || Constants.DEFAULT_GRAPH_COLOR;
                this.printManager.y = this.printManager.startTop = this.countersTop + PrintManager.yPadding;
                this.printManager.x = this.printManager.startLeft = PrintManager.pageLeft + j * (summaryWidth + PrintManager.spacing) + PrintManager.xPadding;

                let graphName = summaryTypeRows[i][j].graphTitle ?? AnalyticsTypes.getLabel(summaryTypeRows[i][j].dataSource) + " " + AnalyticsTypes.getLabel(summaryTypeRows[i][j].metric);
                this.printManager.addLineToDoc(graphName, {size: 'h1'});
                this.printManager.y += 1;
                this.printManager.addToDoc(AnalyticsTypes.applyFormat(summaryTypeRows[i][j], GraphUtil.aggregate(summaryTypeRows[i][j], AnalyticsEngine.getData(summaryTypeRows[i][j], timeInterval))), {
                    size: 'h1',
                    color: color
                });
                //console.log(summaryTypes[i]);
                //console.log(timeInterval);
                //console.log(AnalyticsEngine.getDataset(summaryTypes[i], timeInterval));
                this.printManager.y += .5;
                this.printManager.x += 3;
                if (summaryTypeRows[i][j].showPercentIncrease) {
                    let percentChanged = GraphUtil.calculatePercentChange(summaryTypeRows[i][j], AnalyticsEngine.getData(summaryTypeRows[i][j], timeInterval), AnalyticsEngine.getData(summaryTypeRows[i][j],
                        DashboardDateUtil.getPreviousTimeInterval()))
                    let percentColor = percentChanged >= 0 ? 'percentGreen' : 'percentRed';
                    this.printManager.addLineToDoc(Math.round(Math.abs(percentChanged) * 100) + "%", {
                        size: 'h3',
                        color: percentColor
                    });
                    this.printManager.addLineToDoc(" ", {size: 'h3'});
                }

                if (this.countersHeight < this.printManager.y - this.printManager.getLineHeight() / 2 - this.countersTop + PrintManager.yPadding)
                    this.countersHeight = this.printManager.y - this.printManager.getLineHeight() / 2 - this.countersTop + PrintManager.yPadding;
            }
        }

        console.log(this.countersTop);
        console.log(this.countersHeight);
        this.linesTop = this.printManager.y = this.countersTop + this.countersHeight + PrintManager.spacing;

        this.linesWidth = (PrintManager.pageWidth - PrintManager.spacing) / 2;

        // This seems to render the white boxes for the graphs?
        /*if (this.countersHeight) {
            //let rectHeight = this.linesHeight;
            let rectHeight = 60.0;
            this.printManager.rect('white', PrintManager.pageLeft, this.linesTop, this.linesWidth, rectHeight);
            this.printManager.rect('white', PrintManager.pageLeft + this.linesWidth + PrintManager.spacing, this.linesTop, this.linesWidth, rectHeight);
        }*/

        /*
         * render detail graphs
         */
        //x = this.pageLeft;
        //let allGraphTypes:Array<GraphSettings> = GraphUtil.getDetailGraphs(GraphUtil.getCurrentAnalyticsPage(project));
        let allDetailGraphTypes:Array<GraphSettings> = GraphUtil.getDetailGraphs(pageSettings);
        let graphTypes = [];
        for (let detailGraphType of allDetailGraphTypes) {
            if (!detailGraphType.hidden) {
                graphTypes.push(detailGraphType);
            }
        }

        let beginningY = 0;
        for (let i = 0; i < graphTypes.length; i++) {
            let color = graphTypes[i].graphColor || Constants.DEFAULT_GRAPH_COLOR;
            //y = startTop = linesTop + yPadding;
            //x = startLeft = pageLeft + xPadding;
            // TODO: Account for full / half
            if (i < 2) {
                this.printManager.y = this.printManager.startTop = this.linesTop + PrintManager.yPadding;
            } else if (i == 2) {
                this.printManager.y += PrintManager.yPadding * 2;
                beginningY = this.printManager.y
            } else if (i == 3) {
                //this.printManager.y -= 60; // TODO: here
                this.printManager.y = beginningY;
            } else if (i == 4) {
                this.printManager.y += PrintManager.yPadding * 2;
                beginningY = this.printManager.y
            } else if (i == 5) {
                this.printManager.y = beginningY;
            }

            // White rect for graph
            //let rectHeight = 60.0;
            //this.printManager.rect('white', this.printManager.startLeft, this.printManager.y, this.linesWidth, rectHeight);
            //x = startLeft = pageLeft + linesWidth + spacing + xPadding;

            var index = i < 2 ? i : i < 4 ? i-2 : i-4;
            let graphWidth = (graphTypes[i].graphWidth == "full" ? this.linesWidth * 2 : this.linesWidth) - 2 * PrintManager.xPadding
            this.printManager.x = this.printManager.startLeft = PrintManager.pageLeft + index * (this.linesWidth + PrintManager.spacing) + PrintManager.xPadding;
            let graphName = graphTypes[i].graphTitle ?? AnalyticsTypes.getLabel(graphTypes[i].dataSource) + " " + AnalyticsTypes.getLabel(graphTypes[i].metric);
            //console.log(graphName);
            this.printManager.addLineToDoc(graphName, {size: 'h1'});

            //y = startTop;
            //x = startLeft + linesWidth - 2 * xPadding;

            this.printManager.hLine('lightgrey', this.printManager.x, this.printManager.y + PrintManager.yPadding / 2, graphWidth);

            this.printManager.y = this.printManager.startTop = this.printManager.y + 3 * PrintManager.yPadding / 2;
            //x = startLeft;

            /*
             * Render stats bar
             */
            let analyticDataset = AnalyticsEngine.getDataset(graphTypes[i], timeInterval);
            let stats = GraphUtil.generateStats(GraphUtil.aggregate(graphTypes[i], analyticDataset), timeInterval, color);
            let dataset = AnalyticsEngine.getDataset(graphTypes[i], timeInterval);
            let fullDataset = DatasetUtil.generateChartDataset(graphTypes[i], dataset, timeInterval, color);
            if (graphTypes[i].showStatistics) {
                for (let i = 0; i < stats.length; i++) {
                    this.printManager.addToDoc(stats[i].label + ' ', {size: 'h2'});
                    this.printManager.addToDoc(stats[i].value + ' ', {size: 'h2', color: stats[i].color});
                    if (i < stats.length - 1) this.printManager.addToDoc(' /  ', {size: 'h2'});
                }
            }
            if (graphTypes[i].showStatistics) {
                this.printManager.y += this.printManager.getLineHeight() + 1;
            }

            /*
             * Render Charts
             */
            let y = this.printManager.y;
            //console.log(fullDataset);
            if (graphTypes[i].chartType == Constants.CHART_TYPE_LIST) {
                this.printTableView(fullDataset);
            } else {
                let result = await this.renderChart(graphTypes[i], fullDataset.data, {
                    x: this.printManager.startLeft,
                    y,
                    width: graphWidth
                });
                this.printManager.y += result ? result.height : 0;
                //console.log(result);
                //this.printManager.y += 41.34;
            }
        }
    }

    public static async renderChart(graphSettings:GraphSettings, data:any, params:any) {
        let width = Math.round(params.width * 5);
        //let height = chart === Constants.CHART_TYPE_DONUT ? width : Math.round(width * 0.5);
        let height = Math.round(width * 0.5);
        //console.log(width + " : " + height);
        let id = 'tmpCanvas' + Math.random().toString(36).substr(2, 5);

        let node = document.createElement('div');
        node.style.visibility = 'hidden';
        node.style.position = 'relative';
        node.innerHTML = `<div style="width: ${width}px; height ${height}px; position: absolute; bottom: 0; pointer-events: none;">
            <canvas id="${id}" width="${width}" height="${height}"></canvas>
        </div>`;
        document.body.appendChild(node);

        let canvas: HTMLCanvasElement = document.getElementById(id) as any;
        let options;
        let instance;
        let result;
        //chart = chart ?? Constants.CHART_TYPE_LINE;
        switch (graphSettings.chartType) {
            case Constants.CHART_TYPE_LINE:
                options = Object.assign({}, ChartOptions.LineChartOptions(graphSettings, null), { print: true });
                // @ts-ignore
                instance = new LChart(
                    canvas.getContext("2d"),
                    {
                        type: 'StyledLine',
                        data,
                        options
                    }
                );
                result = await ExportUtil.copyCanvas(this.printManager.getDoc(), canvas, params);
                instance.destroy();
                break;
            case Constants.CHART_TYPE_DONUT:
                options = Object.assign({}, ChartOptions.DoughnutChartOptions(graphSettings), { print: true, width });
                // @ts-ignore
                instance = new DChart(
                    canvas.getContext("2d"),
                    {
                        type: 'StyledDoughnut',
                        data: customToNormalData(data),
                        options
                    }
                );
                result = await ExportUtil.copyCanvas(this.printManager.getDoc(), canvas, params);
                instance.destroy();
                break;
            case Constants.CHART_TYPE_BAR:
                options = Object.assign({}, ChartOptions.StackedBarChartOptions(graphSettings, null), { print: true });
                // @ts-ignore
                instance = new BChart(
                    canvas.getContext("2d"),
                    {
                        type: 'StyledStackedBar',
                        data,
                        options
                    }
                );
                result = await ExportUtil.copyCanvas(this.printManager.getDoc(), canvas, params);
                instance.destroy();
                break;
        }
        document.body.removeChild(node);

        return result;
    }

    public static printTableView(data:Array<any>) {
        if (data.length == 0) {
            this.printManager.addToDoc("No data", {size: 'h3', width:70});
            this.printManager.y += 45.0;
            return;
        }
        let yValue = 0;
        let objectsKeys = Object.keys(data[0]);
        this.printManager.x = this.printManager.startLeft;
        for (let dataItem of data) {
            //this.printManager.addToDoc(objectsKeys[0] + ' ', {size: 'h2', width:70});
            for (let objectKey of objectsKeys) {
                let dataItemFormatted = objectKey == "date" ? moment(dataItem[objectKey], "YYYYMMDD").format("MM/DD/YYYY") : dataItem[objectKey];
                if (dataItemFormatted.length > 47) {
                    dataItemFormatted = dataItemFormatted.substring(0,47) + "...";
                }
                if (isNaN(dataItemFormatted)) {
                    dataItemFormatted = dataItemFormatted.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
                }

                this.printManager.addToDoc(dataItemFormatted + ' ', {size: 'h3', width:70});
            }
            //this.printManager.hLine('lightgrey', this.printManager.x, this.printManager.y + 5, this.linesWidth - 2 * PrintManager.xPadding);
            this.printManager.x = this.printManager.startLeft;
            this.printManager.y += 10;
            yValue += 10;
        }
        this.printManager.y += (41.34 - yValue);
    }

    //
    // Util methods
    //

    public static findRoot(type:any, node:any) {
        let getRoot = (node:any) => {
            let name = node.nodeName || node.tagName || '';
            if (name.match(new RegExp('^' + type + '$', 'i')))
                return node;
            if (node.children) {
                for (let i = 0; i < node.children.length; i++) {
                    let sub:any = getRoot(node.children[i]);
                    if (sub)
                        return sub;
                }
            }
            return null;
        }

        return getRoot(node);
    }

    public static canvasScreenshot(canvas:any) {
        if (!HTMLCanvasElement.prototype.toBlob) {
            Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                value: function (callback:any, type:any, quality:any) {
                    var canvas = this;
                    setTimeout(function() {
                        var binStr = atob( canvas.toDataURL(type, quality).split(',')[1] ),
                            len = binStr.length,
                            arr = new Uint8Array(len);

                        for (var i = 0; i < len; i++ ) {
                            arr[i] = binStr.charCodeAt(i);
                        }

                        callback( new Blob( [arr], {type: type || 'image/png'} ) );
                    });
                }
            });
        }

        return new Promise((resolve, reject) => {
            try {
                canvas.toBlob((blob:any) => {
                    try {
                        let mem = new FileReader();
                        mem.onload = e => resolve(e.target.result);
                        mem.onerror = error => reject(error);
                        mem.readAsDataURL(blob);
                    } catch (error) {
                        return reject(error);
                    }
                });
            } catch (error) {
                return reject(error);
            }
        });
    }

    public static async copyCanvas(doc:any, node:any, params:any) {
        try {
            let canvas = ExportUtil.findRoot('canvas', node);
            //console.log(canvas);
            if (!canvas)
                return null;

            let image = await ExportUtil.canvasScreenshot(canvas);
            if (!image)
                return null;

            // TODO: somewhere in here is maybe where we add multiple pages?
            let scale = canvas.width / canvas.height;
            if (params.width && !params.height) {
                params.height = params.width / scale;
            } else if (params.height && !params.width) {
                params.width = params.height * scale;
            } else if (!params.width && !params.height) {
                params.width = canvas.width;
                params.height = canvas.height;
            }

            doc.addImage(image, 'png', params.x || 0, params.y || 0, params.width, params.height);
            return { x: params.x || 0, y: params.y || 0, width: params.width, height: params.height };
        } catch (error) {
            console.error(error);
        }
        return null;
    }
}